import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {GtmEnum} from "../models/gtm.enum";
import {v4 as uuidv4} from 'uuid';
import {OrderTrackingEntry} from "../../data/models/order-tracking-entry.model";
import {HttpClient} from "@angular/common/http";
import {DatePipe, isPlatformBrowser} from "@angular/common";
import {LoginService} from '../components/login/login.service';

@Injectable({providedIn: 'root'})
export class OrderTrackingService {

  transactionId : string;
    constructor(
        private http: HttpClient,
        private datePipe: DatePipe,
        private loginService: LoginService,
        @Inject(PLATFORM_ID) private platformId,
    ) {
    }

    pushEvent(event: GtmEnum, eventData: object): void {

      try {
        if (isPlatformBrowser(this.platformId) && dataLayer !== undefined && dataLayer !== null) {
          const filteredData: any = {...eventData['body'] ?? eventData};
          delete filteredData.registerPassword;
          delete filteredData.deliveryAddress;
          delete filteredData.billingAddress;
          delete filteredData.bonusAddress;
          delete filteredData.payment;
          delete filteredData.billingAddressList;
          delete filteredData.deliveryAddressList;
          delete filteredData.paymentList;
          delete filteredData.email;
          delete filteredData.selectedGiftList;
          delete filteredData.additionalData;

          // P5W-4011 (add userSSOId to GTM)
          this.loginService.getUserData().subscribe(userDataSso => {
            if(userDataSso.userSSOId) {
              filteredData.userSSOId = userDataSso.userSSOId;
            }
          });

          const pushData = {event, objectData: JSON.stringify(filteredData)};
          dataLayer.push(pushData);
        }
      } catch (e) {
        // Datalayer ist wohl nicht da..
      }

        if(event !== GtmEnum.SITE_NAVIGATION) {
          let eventDataList = [];
          const filteredData: any = {...eventData['body'] ?? eventData};
          if(!Array.isArray(filteredData)) {
            delete filteredData.registerPassword;
            eventDataList.push(filteredData);
          } else {
            filteredData.forEach(o => delete o.registerPassword)
            eventDataList = filteredData;
          }
          if (isPlatformBrowser(this.platformId)) {
            try {
              let orderStep = new OrderTrackingEntry();

              orderStep.ts = this.datePipe.transform(Date(), 'yyyy-MM-dd HH:mm:ss');
              orderStep.transactionId = this.transactionId;
              orderStep.eventType = event.toString().toUpperCase();
              orderStep.eventData = eventDataList;

              this.http.post('webabo/tracking/orderevent', orderStep).subscribe(success => success);
            } catch (e) {
              console.error("Error while saving tracking: " + e);
            }
          }
        }
    }

    generateTransactionId(): void {
      this.transactionId = uuidv4();
    }

    getTransactionId() {
      return this.transactionId;
    }
}
